var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e420d087-3277-48fe-80fe-59ddecaab9b1,.eb2a34d0-8b06-4f99-adfe-7bdb3d5e16f8{fill:none;}.abe52ff7-0345-45a6-bcdc-9ebde46242ba{clip-path:url(#f668566a-bf33-43f7-8947-668e03c71ce4);}.fd92bba7-778f-446b-94af-dcccd7f72e54{fill:#fff;}.e420d087-3277-48fe-80fe-59ddecaab9b1{stroke:#fff;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "f668566a-bf33-43f7-8947-668e03c71ce4",
    transform: "translate(0 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "eb2a34d0-8b06-4f99-adfe-7bdb3d5e16f8",
    width: 200,
    height: 200
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "armatura_dubla_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bcfcf839-7943-4813-bb28-62b94b3bad9d",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "abe52ff7-0345-45a6-bcdc-9ebde46242ba"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fd92bba7-778f-446b-94af-dcccd7f72e54",
    d: "M190-25.15v209.3a4,4,0,0,1-4,4H14a4,4,0,0,1-4-4V-21.15a4,4,0,0,1,4-4H190M200-33a4,4,0,0,0-4-4H4a4,4,0,0,0-4,4V196a4,4,0,0,0,4,4H196a4,4,0,0,0,4-4Z",
    transform: "translate(0 37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e420d087-3277-48fe-80fe-59ddecaab9b1",
    x: 40,
    y: 5.01,
    width: 120,
    height: 190.4,
    rx: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestActive);
export default __webpack_public_path__ + "static/media/test_active.1869e3e9859ac1e47810f79b02c12c9e.svg";
export { ForwardRef as ReactComponent };